/**
 * Create value that references itself, similar to the Y combinator
 */
export function self<T>(fn: (value: () => T) => T): T {
  const value = fn(() => value);
  return value;
}

export function identity<T>(value: T): T {
  return value;
}

export function voidFn() {}
